// Add these to your existing all_routes object
const all_routes = {   
   dashboard: "/",
   salesdashboard: "/sales-dashboard",
   email: "/email",
   productlist: "/product-list",
   categorylist: "/category-list",
   brandlist: "/brand-list",
   units: "/units",
   tax: "/tax",
   purchaselist: "/purchase-list",
   purchaseorderreport: "/purchase-order-report",
   purchasereturn:"/purchase-returns",
   purchaseOrderInvoice: "/purchase-order-invoice",
   managestock: "/manage-stocks",
   saleslist: "/sales-list",
   addsale: "/add-sales",
   salesinvoicereport: "/sales-invoices",
   salesreturn: "/sales-returns",
   addsalesreturn: "/add-sales-return",
   quotationlist: "/quotation-list",
   createquotation: "/create-quotation",
   expenselist: "/expense-list",
   expensecategory: "/expense-category",
   bankaccountlist:'/bank-accounts',
   balancesheet:'/balance-sheet',
   trialbalance:'/trial-balance',
   accountstatement:'/account-statement',
   openingbalancereport: "/opening-balance",
   openingBalanceEntry: "/opening-balance-entry",
   customers: "/customers",
   suppliers: "/suppliers",
   salesreport: "/sales-report",
   purchasereport: "/purchase-report",
   inventoryreport: "/inventory-report",
   supplierreport: "/supplier-report",
   customerreport: "/customer-report",
   expensereport: "/expense-report",
   incomereport: "/income-report",
   taxreport: "/tax-report",
   profitloss: "/profit-loss-report",
   users: "/users",
   rolespermission: "/roles-permissions",
   deleteaccount: "/delete-account",
   profile: "/profile",
   signin: "/signin",
   register: "/register",
   companysettings: "/company-settings",
   lockscreen: "/lock-screen",
   resetpasswordThree: "/reset-password",
   forgotPasswordThree: "/forgot-password",
   barcode: "/print-barcode",
   qrcode: "/qrcode",
   
   // ADD THESE MISSING ROUTES
   // login: "/signin", // Alias for signin
   // forgotPassword: "/forgot-password",
   // resetPassword: "/reset-password-3",
   // resetPasswordWithToken: "/reset-password/:token",
   // changePassword: "/change-password",

  // Manufacturing Module Routes
  manufacturingDashboard: "/manufacturing/dashboard",  // NEW!
  rawMaterialMaster: "/manufacturing/raw-material-master",  // NEW!
  rawMaterialPurchase: "/manufacturing/raw-material-purchase",
  rawMaterialDispatch: "/manufacturing/dispatch",
  rawMaterialReceive: "/manufacturing/receive",
  manufacturingStock: "/manufacturing/stock",  // NEW!
  productionEntry: "/manufacturing/production",
  productionHistory: "/manufacturing/history",
  stockTransfer: "/manufacturing/transfer",
  wasteEntry: "/manufacturing/waste",
  convertToPurchase: "/manufacturing/convert",
  manufacturingReports: "/manufacturing/reports",
};
export default all_routes;